// PostCard.jsx
import React, { useState } from "react";
import PostHeader from "./PostHeader";
import PostMedia from "./PostMedia";
import PostFooter from "./PostFooter";
import { Icon } from "@iconify/react";

const PostCard = ({
  post,
  className,
  currentUserId,
  BASE_URL,
  handlers,
  isPublic = false,
  feedType,
  hideFollowButton = false,
  followLoading = {},
  onReport,
  autoOpenLikes = false,
  currentUserRole,
}) => {
  const isRepost = post?.type === "REPOST";
  const originalPost = post?.post;
  const [expandedPostsDescription, setExpandedPostsDescription] = useState({});

  return (
    <div className={`feed-post-card ${className || ""}`}>
      {/* ================= NORMAL POST ================= */}
      {!isRepost && (
        <>
          <PostHeader
            post={post}
            currentUserId={currentUserId}
            isPublic={isPublic}
            feedType={feedType}
            hideFollowButton={hideFollowButton}
            followLoading={followLoading}
            onFollowToggle={handlers?.onFollowToggle}
            onEdit={handlers?.onEdit}
            onSave={handlers?.onSave} // ← ADD THIS LINE
            onDelete={handlers?.onDelete}
            onReport={onReport}
            currentUserRole={currentUserRole}
          />

          {post?.description && (
            <div className="post-text-wrapper">
              <p
                className={`post-text m-0 ${expandedPostsDescription[post._id] ? "expanded" : ""}`}
              >
                {post.description}
              </p>

              {post.description.length > 600 && (
                <span
                  className="see-more-btn theme-color"
                  onClick={() =>
                    setExpandedPostsDescription((prev) => ({
                      ...prev,
                      [post._id]: !prev[post._id],
                    }))
                  }
                >
                  {expandedPostsDescription[post._id] ? "See less" : "See more"}
                </span>
              )}
            </div>
          )}

          <PostMedia
            post={post}
            BASE_URL={BASE_URL}
            handlers={handlers}
            onVideoPlay={handlers?.onVideoPlay}
            videoRefs={handlers?.videoRefs}
          />

          <PostFooter
            post={post}
            feedType={feedType}
            onLike={handlers?.onLike}
            onSave={handlers?.onSave}
            onComment={handlers?.onComment}
            onShare={handlers?.onShare}
            autoOpenLikes={autoOpenLikes}
          />
        </>
      )}

      {/* ================= REPOST ================= */}
      {isRepost && originalPost && (
        <>
          <PostHeader
            post={{
              user: post?.repostedBy,
              createdAt: post?.createdAt,
              isFollowing: post?.repostedBy?.isFollowing,
              _id: post?._id,
            }}
            currentUserId={currentUserId}
            isPublic={isPublic}
            hideFollowButton={hideFollowButton}
            followLoading={followLoading}
            onFollowToggle={handlers?.onFollowToggle}
            onEdit={() => {}}
            onSave={handlers?.onSave} // ← ADD THIS LINE
            onDelete={handlers?.onDelete}
            onReport={onReport}
            hideActionButton={post?.repostedBy?._id !== currentUserId}
            hideEditButton={true}
            currentUserRole={currentUserRole}
          />

          <div className="bg-light p-2 mt-2 rounded">
            <span className="text-muted small">
              <Icon icon="mdi:repeat" /> Reposted
            </span>

            {/* ORIGINAL USER HEADER */}
            <PostHeader
              post={originalPost}
              currentUserId={currentUserId}
              isPublic={isPublic}
              hideFollowButton={hideFollowButton}
              followLoading={followLoading}
              onFollowToggle={handlers?.onFollowToggle}
              onEdit={handlers?.onEdit}
              onSave={handlers?.onSave} // ← ADD THIS LINE
              onDelete={handlers?.onDelete}
              onReport={onReport}
              hideActionButton={false}
              hideEditButton={false}
              currentUserRole={currentUserRole}
            />

            {originalPost?.description && (
              <p className="post-text">{originalPost.description}</p>
            )}

            <PostMedia
              post={originalPost}
              BASE_URL={BASE_URL}
              handlers={handlers}
              onVideoPlay={handlers?.onVideoPlay}
              videoRefs={handlers?.videoRefs}
            />

            {/* ORIGINAL POST FOOTER */}
            <PostFooter
              post={originalPost}
              feedType={feedType}
              onLike={handlers?.onLike}
              onSave={handlers?.onSave}
              onComment={handlers?.onComment}
              onShare={handlers?.onShare}
              autoOpenLikes={autoOpenLikes}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default PostCard;
